import React, { useState } from 'react';
import { Link } from 'react-router-dom';
// import { useTranslation } from 'react-i18next';

// Assets
import simcase_logo from '../assets/icon.png';

const SimCard = ({
  _id,
  title,
  description,
  isPreview = false,
  onPreview = null,
  disableButtons = false,
}) => {
  // State
  // const [isPreview, setIsPreview] = useState(false);

  // Methods
  const handlePreview = () => {
    if (onPreview) {
      onPreview(_id);
    }
    // setIsPreview();
  };

  // Logic
  const bgClass = isPreview
    ? 'bg-primary bg-opacity-10 border-primary'
    : 'bg-light border-secondary';

  const btnPreviewClass = isPreview ? 'btn-primary' : 'btn-light';

  return (
    <div className={`card ${bgClass} border-1`}>
      <div className='card-body'>
        <div className='d-flex align-items-center'>
          <div className='d-flex sim-info'>
            <img
              src={simcase_logo}
              className='me-3'
              alt={title}
              style={{ height: '50px', width: 'auto' }}
            />

            <div className='font-italic'>
              <h5 className='text-dark mb-1'>{title}</h5>
              <p className='text-secondary leadx mb-0'>{description}</p>
            </div>
          </div>

          {!disableButtons && (
            <div className='text-end sim-links ms-auto'>
              <Link
                to={`/games/new?sid=${_id}`}
                className='btn btn-sm btn-dark w-100'>
                Select
              </Link>
              <br />
              <button
                className={`btn btn-sm ${btnPreviewClass} mt-2 w-100`}
                onClick={handlePreview}>
                Preview
              </button>
              {/* <Link
              to={`${process.env.REACT_APP_GAME_URL}/preview?sid=${_id}`}
              target='_blank'
              rel='noopener noreferrer'
              aria-label='preview'
              className='btn btn-sm btn-light mt-2 w-100'>
              Preview
            </Link> */}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SimCard;
